import { render, staticRenderFns } from "./DownloadDocument.vue?vue&type=template&id=2d0e52b4&scoped=true&"
import script from "./DownloadDocument.vue?vue&type=script&lang=js&"
export * from "./DownloadDocument.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDocument.vue?vue&type=style&index=0&id=2d0e52b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e52b4",
  null
  
)

component.options.__file = "DownloadDocument.vue"
export default component.exports